import * as React from 'react'
import { Text } from '$views/components/Text'
import { ModalBox } from '$views/components/ModalBox'

interface Props {
  onAccept: () => void
}

export const ConfirmRegistrationSuccess: React.SFC<Props> = ({ onAccept }) => (
  <ModalBox onAcceptClick={onAccept} simple buttonLabel={'OK'}>
    <Text title>Comprueba tu correo electrónico</Text>
    <Text marginTop="mini">
      Te hemos enviado un enlace de activación para que confirmes tu dirección de correo. Si tardas en recibirlo, mira
      en tu bandeja de Spam por si acaso
    </Text>
  </ModalBox>
)



// WEBPACK FOOTER //
// ./src/views/components/Forms/ConfirmRegistrationSuccess.tsx